<template>
  <div class='new-project-scoping-started'>
    <div class="new-project-scoping-started-message-area">
      <div class="new-project-scoping-started-message verify-text">
        {{ $t('new.project.scoping.started.message') }}
      </div>
      <v-btn class="new-project-scoping-started-close-button" color="primary" @click="backToProjects()">{{ $t('back.to.projects') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { views } from '@/router/constants';

export default {
  name: 'NewProjectScopingStarted',
  methods: {
    async backToProjects() {
      await this.$router.push({ name: views.ACTIVITY_LOG });
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.new-project-scoping-started {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin-top: 10%;

  .new-project-scoping-started-message-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    max-width: rem(385);
    min-width: rem(200);
    padding: rem(32) rem(29);
    border-radius: $radius-md;
    background-color: var(--bg-primary);
    box-shadow: 0 0 rem(5) 0 rgba(14, 31, 51, 0.13);

    .new-project-scoping-started-close-button {
      margin: 0 rem(77);
    }

    .new-project-scoping-started-message {
      padding: 0 rem(30);
      margin-bottom: rem(40);
      text-align: center;
      color: var(--text-primary);
      font-size: rem(18);
      letter-spacing: 0;
      line-height: rem(24);
      font-family: $font-family-medium;
    }
  }
}
</style>
